import "./Star.scss";

const Star = ({filled}) => {
    return (
        <span style={{color: filled ? "#FFD700" : "#ccc", fontSize: "1em"}}>
      ★
    </span>
    );
};

export {Star};

